import { HeroUIProvider } from '@heroui/react';
import ReactDOM from 'react-dom/client';
import './global.css';
import Home from './page';

ReactDOM.createRoot(document.getElementById('app') as HTMLElement).render(
  <HeroUIProvider>
    <div className="w-screen h-screen p-8 pb-10 flex items-start justify-center m-auto" style={{ maxWidth: '1040px' }}>
      <Home />
    </div>
  </HeroUIProvider>,
);
